import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';
import { IChecklistV2ForList } from '@fi-shared/checklist/checklist-v2';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-checklist2-list-schedule-name',
    templateUrl: './fi-checklist2-list-schedule-name.component.html',
    styleUrls: ['./fi-checklist2-list-schedule-name.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { host: 'fi-checklist2-list-schedule-name' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2ListScheduleNameComponent }],
    standalone: false,
})
export class FiChecklist2ListScheduleNameComponent extends FiWrapperTableAdditionalColumns {
    constructor(private appTextService: AppTextService) {
        super();
    }

    getScheduleName(item: IChecklistV2ForList) {
        if (item.ScheduleId) {
            return item.ScheduleName;
        }
        return this.appTextService.get('checklist.not_scheduled');
    }
}
